(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["classrooms/qr-code/includes/_feedback_messages.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
if(runtime.contextOrFrameLookup(context, frame, "message") == "wish_to_continue") {
output += "\n    ";
output += runtime.suppressValue((lineno = 1, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["You are about to generate a new sign-in QR code for %(num)d selected student. This will cancel any previously issued code.","You are about to generate new sign-in QR codes for all %(num)d selected students. This will cancel any previously issued codes.",runtime.contextOrFrameLookup(context, frame, "std_length"),runtime.makeKeywordArgs({"num": runtime.contextOrFrameLookup(context, frame, "std_length")})])), env.opts.autoescape);
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message") == "success") {
output += "\n    ";
output += runtime.suppressValue((lineno = 3, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["%(num)d student sign-in QR Code was successfully generated with no errors.","%(num)d students sign-in QR Codes were successfully generated with no errors.",runtime.contextOrFrameLookup(context, frame, "std_length"),runtime.makeKeywordArgs({"num": runtime.contextOrFrameLookup(context, frame, "std_length")})])), env.opts.autoescape);
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message") == "select_message") {
output += "\n    ";
output += runtime.suppressValue((lineno = 5, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["%(num)d students have been selected.","%(num)d students have been selected.",runtime.contextOrFrameLookup(context, frame, "std_length"),runtime.makeKeywordArgs({"num": runtime.contextOrFrameLookup(context, frame, "std_length")})])), env.opts.autoescape);
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message") == "success_student_string") {
output += "\n    ";
output += runtime.suppressValue((lineno = 7, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["%(num)d student","%(num)d students",runtime.contextOrFrameLookup(context, frame, "std_length"),runtime.makeKeywordArgs({"num": runtime.contextOrFrameLookup(context, frame, "std_length")})])), env.opts.autoescape);
output += "\n";
;
}
else {
if(runtime.contextOrFrameLookup(context, frame, "message") == "success_string") {
output += "\n    ";
output += runtime.suppressValue((lineno = 9, colno = 15, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "ngettext"), "ngettext", context, ["sign-in QR Codes were successfully generated with %(num)d error.","sign-in QR Codes were successfully generated with %(num)d errors.",runtime.contextOrFrameLookup(context, frame, "std_length"),runtime.makeKeywordArgs({"num": runtime.contextOrFrameLookup(context, frame, "std_length")})])), env.opts.autoescape);
output += "\n";
;
}
;
}
;
}
;
}
;
}
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();

define("apps/classrooms/templates/qr-code/includes/_feedback_messages", function(){});

